import { ECGDiagnosticCode } from 'pages/Diagnostics/types'
import { ecgTypes } from 'pages/Diagnostics/constants/diagnostic_types'
import { IExamResponse } from 'types/exam/types'

/**
 * Hook para verificar se uma derivação específica está destacada
 * baseado nas análises do exame
 */
export const useECGHighlight = (exameData: IExamResponse) => {
  const isHighlighted = (leadName: string): boolean => {
    return exameData.exam_results.some(result => {
      const diagnosisData = ecgTypes[result.result_type as ECGDiagnosticCode]
      return diagnosisData?.leads
        .map(l => l.toLocaleLowerCase())
        .includes(leadName.toLocaleLowerCase())
    })
  }

  return { isHighlighted }
}
